import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RestApiService {

  constructor(public httpClient: HttpClient, private angularFirestore: AngularFirestore) { }


  getAllContact() {
    return this.angularFirestore.collection('contactForm').snapshotChanges();
  }

  addCountryInforamtion(data) {
    return this.angularFirestore.collection('contactForm').add(data);
  }


  sendEmail(data) {
    return this.httpClient.post(environment.apiBaseUrl+'sendmail', data);
  }

}
